import { hasAccess, type AccessLevel } from "@woven/contracts";
import { House, ScrollText, Server, Settings, ShieldCheck, type LucideIcon } from "lucide-react";

export interface ConsoleNavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  minimum: AccessLevel;
  /** Optional visible badge, e.g. "[Admin]" for the admin section. */
  badge?: string;
}

/**
 * Everything visible in the console sidebar. Access is enforced by route
 * guards too — hiding an item is presentation, never authorization.
 */
export const CONSOLE_NAV_ITEMS: readonly ConsoleNavItem[] = [
  { to: "/console", label: "Overview", icon: House, minimum: "lite" },
  { to: "/console/servers", label: "Servers", icon: Server, minimum: "lite" },
  { to: "/console/logs", label: "Logs", icon: ScrollText, minimum: "lite" },
  { to: "/console/account", label: "Settings", icon: Settings, minimum: "lite" },
  {
    to: "/console/admin",
    label: "Admin",
    icon: ShieldCheck,
    minimum: "admin",
    badge: "[Admin]",
  },
] as const;

export function consoleNavFor(access: AccessLevel): ConsoleNavItem[] {
  return CONSOLE_NAV_ITEMS.filter((item) => hasAccess(access, item.minimum));
}
